var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleMinus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.144,
    height: 38.144,
    viewBox: "0 0 38.144 38.144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:currentColor}.cls-2{fill:#fff}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8397",
    transform: "translate(-1214.953 -376.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5947",
    d: "M13.486 0A13.486 13.486 0 1 1 0 13.486 13.486 13.486 0 0 1 13.486 0z",
    className: "cls-1",
    transform: "rotate(-45 1085.393 -1268.619)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117",
    cx: 12.137,
    cy: 12.137,
    r: 12.137,
    className: "cls-2",
    transform: "rotate(-45 1086.347 -1270.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118",
    cx: 10.114,
    cy: 10.114,
    r: 10.114,
    className: "cls-1",
    transform: "rotate(-45 1087.777 -1274.374)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8192",
    transform: "translate(1228.968 390.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7283",
    d: "M0 0H1.349V10.114H0z",
    className: "cls-2",
    transform: "rotate(90 2.865 7.249)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleMinus);
export default __webpack_public_path__ + "static/media/circle_minus.64d05d2da52d569c3e4a7e650d621d0e.svg";
export { ForwardRef as ReactComponent };